import evenMoreSimpleCache from '~/services/evenMoreSimpleCache'
import useUrl from './helpers/useUrl'

/** @param {import("@nuxtjs/axios").NuxtAxiosInstance} client */
export default (client, { apiUrl }) => {
  const root = useUrl(apiUrl)
  return {
    async getBaseConfig() {
      const url = root('fe-shared/public/config')
      return evenMoreSimpleCache({ apiClosure: () => client.get(url), id: url })
    },
  }
}
